import { AddonInfo } from '../types';

import { getPluginInfo } from './jira';

const SUPPORT_PORTAL_URL =
  'https://appfire.atlassian.net/servicedesk/customer/portal/11/group/36/create/163';
const APP_NAME_FIELD = 'customfield_10149';
const PLATFORM_FIELD = 'customfield_10161';
const INSTANCE_ADDRESS_FIELD = 'customfield_10205';
const SEN_FIELD = 'customfield_10210';

const TOGGL = '10825';
const CLOUD = '10935';
const ADDON_KEY = 'toggl';

function getSearchParams(hostUrl: string) {
  const searchParams = new URLSearchParams();
  searchParams.set(APP_NAME_FIELD, TOGGL);
  searchParams.set(PLATFORM_FIELD, CLOUD);
  searchParams.set(INSTANCE_ADDRESS_FIELD, hostUrl);
  return searchParams;
}

function getSearchParamsWithSEN(pluginInfo: AddonInfo, hostUrl: string) {
  const searchParams = getSearchParams(hostUrl);
  searchParams.set(
    SEN_FIELD,
    (pluginInfo.license && pluginInfo.license.entitlementId) || ''
  );
  return searchParams;
}

export async function buildSupportUrl(hostUrl: string) {
  try {
    const pluginInfo = await getPluginInfo(ADDON_KEY);
    const searchParams = getSearchParamsWithSEN(pluginInfo, hostUrl);

    return new URL(`${SUPPORT_PORTAL_URL}?${searchParams.toString()}`);
  } catch (error) {
    console.warn('Cannot get plugin info', error);
    const searchParams = getSearchParams(hostUrl);
    return new URL(`${SUPPORT_PORTAL_URL}?${searchParams.toString()}`);
  }
}
